export const GAME_KEY_MAP: {
	[key: string]: string;
} = {
	'in.ludo.supreme': 'ludo',
	'in.ludo.supremegold': 'ludo',
	'in.ludo.ninjagold': 'ninja',
	'in.ludo.ninja': 'ninja',
	'in.snl.plus': 'snl',
	'in.snl.plusgold': 'snl',
	'in.crush.chocogold': 'cc',
	'com.zupee.free': 'zcm'
};

export const DATA_TYPES = {
	STRING: 'string',
	JSON: 'json',
	NUMBER: 'number',
	NULL: 'null',
	ARRAY: 'array',
	BOOLEAN: 'boolean'
};

export const ZOOKEEPER_ENDPOINTS = {
	LIST_SERVICES: '/marketing/gameAdmin/zookeeper/listServices',
	LIST_KEYS: '/marketing/gameAdmin/zookeeper/listKeys',
	UPDATE_KEY: '/marketing/gameAdmin/zookeeper/updateKey',
	GET_KEY: '/marketing/gameAdmin/zookeeper/getValueForKey',
	GET_LOGS: '/marketing/gameAdmin/zookeeper/getZkLogs',
	UPDATE_ZK_UPDATED_REQS: '/marketing/gameAdmin/zookeeper/updateZKUpdateReq',
	GET_ZK_UPDATED_REQS: '/marketing/gameAdmin/zookeeper/getAllPendingZkUpdateReqs',
	GET_OTP: '/marketing/gameAdmin/zookeeper/sendZkUpdateReqOtp'
};

export const BOOLEAN_OPTIONS = [
	{ id: 'true', label: 'True' },
	{ id: 'false', label: 'False' }
];
